/* eslint-disable max-lines */
export const defaultSettings = {
  general: {
    sidebar: {
      isOpen: true
    }
  },
  clinicalNote: {
    hp: {
      enabled: true
    },
    soap: {
      enabled: true
    },
    dap: {
      enabled: false
    },
    mha: {
      enabled: false
    },
    epn: {
      enabled: false
    },
    chart3d: {
      enabled: false
    },
    before_after: {
      enabled: false
    },
    weight_loss_administration: {
      enabled: false
    },
    attachments: {
      enabled: true
    },
    superbill: {
      enabled: true
    },
    myscribe: {
      enabled: false
    },
    vitals: {
      enabled: true
    },
    treatment_plan: {
      enabled: true
    },
    overview: {
      enabled: true,
      vitals: true,
      allergies: true,
      medications: true,
      weight_loss_administration: false,
      vaccines: true,
      alerts: true,
      conditions: true,
      medical_history: true,
      family_history: true,
      social_history: true,
      surgical_history: true,
      growth_chart: false
    },
    macros: {
      enabled: true
    },
    auto_save: {
      enabled: true
    },
    toggleLSidebar: {
      enabled: true
    },
    toggleRSidebar: {
      enabled: false
    },
    templateView: {
      type: 'single',
      advancedTemplate: false
    },
    sections: {
      hp: {
        generalHistory: {
          enabled: true,
          position: null,
          advancedForm: true,
          category: 'history'
        },
        complaints: { enabled: true, position: null, advancedForm: true, category: 'history' },
        hpi: { enabled: true, position: null, advancedForm: true, category: 'history' },
        ros: { enabled: true, position: null, advancedForm: true, category: 'history' },
        medications: { enabled: true, position: null, advancedForm: true, category: 'history' },
        vaccines: { enabled: true, position: null, advancedForm: true, category: 'history' },
        allergies: { enabled: true, position: null, advancedForm: true, category: 'history' },
        socialHistory: { enabled: true, position: null, advancedForm: true, category: 'history' },
        familyHistory: { enabled: true, position: null, advancedForm: true, category: 'history' },
        medicalHistory: {
          enabled: true,
          position: null,
          advancedForm: true,
          category: 'history'
        },
        surgicalHistory: {
          enabled: true,
          position: null,
          advancedForm: true,
          category: 'history'
        },
        test: { enabled: true, position: null, advancedForm: true, category: 'history' },
        weightLossAdministration: {
          enabled: false,
          position: null,
          advancedForm: true,
          category: 'history'
        },
        notes: { enabled: true, position: null, category: 'history' },
        exam: { enabled: true, position: null, advancedForm: true, category: 'physical' },
        vitals: { enabled: true, position: null, advancedForm: true, category: 'physical' },
        diagnosisCodes: { enabled: true, position: null, category: 'assessment' },
        assessment: { enabled: true, position: null, advancedForm: true, category: 'assessment' },
        plan: { enabled: true, position: null, advancedForm: true, category: 'plan' },
        cptCodes: { enabled: true, position: null, category: 'plan' },
        orders: { enabled: true, position: null, category: 'plan' }
      },
      intake: {
        patientNeeds: { enabled: true, position: null },
        problemManifestationDefinition: { enabled: true, position: null },
        diagnosisCodes: { enabled: true, position: null },
        goals: { enabled: true, position: null },
        timeFrames: { enabled: true, position: null },
        medications: { enabled: true, position: null, advancedForm: true },
        vitals: { enabled: true, position: null },
        riskAndCoMorbidities: { enabled: true, position: null },
        cptCodes: { enabled: true, position: null },
        notes: { enabled: true, position: null },
        orders: { enabled: true, position: null }
      },
      soap: {
        subjective: { enabled: true, position: null, category: 'subjective' },
        medications: {
          enabled: true,
          position: null,
          advancedForm: true,
          category: 'subjective'
        },
        patientNeeds: { enabled: false, position: null, category: 'subjective' },
        problemManifestationDefinition: {
          enabled: false,
          position: null,
          category: 'subjective'
        },
        notes: { enabled: true, position: null, category: 'subjective' },
        objective: { enabled: true, position: null, category: 'objective' },
        vitals: { enabled: true, position: null, category: 'objective' },
        assessment: { enabled: true, position: null, category: 'assessment' },
        diagnosisCodes: { enabled: true, position: null, category: 'assessment' },
        plan: { enabled: true, position: null, category: 'plan' },
        cptCodes: { enabled: true, position: null, category: 'plan' },
        goals: { enabled: false, position: null, category: 'plan' },
        orders: { enabled: true, position: null, category: 'plan' }
      },
      progress: {
        goals: { enabled: true, position: null, advancedForm: true },
        session: { enabled: true, position: null, advancedForm: true },
        riskFactors: { enabled: true, position: null, advancedForm: true },
        sessionQuotesAndContents: { enabled: true, position: null, advancedForm: true },
        activeSymptoms: { enabled: true, position: null, advancedForm: true },
        functionalImpairment: { enabled: true, position: null, advancedForm: true },
        interventions: { enabled: true, position: null, advancedForm: true },
        medications: { enabled: true, position: null, advancedForm: true },
        vitals: { enabled: true, position: null, advancedForm: true },
        subjective: { enabled: true, position: null },
        objective: { enabled: true, position: null },
        assessment: { enabled: true, position: null },
        plan: { enabled: true, position: null },
        progress: { enabled: true, position: null, advancedForm: true },
        cptCodes: { enabled: true, position: null, advancedForm: true },
        diagnosisCodes: { enabled: true, position: null, advancedForm: true },
        notes: { enabled: true, position: null },
        orders: { enabled: true, position: null }
      },
      myscribe: {
        recordVisit: { enabled: true, position: null },
        transcript: { enabled: true, position: null }
      }
    }
  },
  appointmentFilters: {
    appointmentType: [],
    appointmentStatus: [],
    appointmentConfirmState: [],
    serviceType: [],
    patient: [],
    practitioners: [],
    selectedView: null
  },
  formBuilder: {
    auto_save: {
      enabled: false
    }
  },
  appointment: {
    details: {
      isOpen: true,
      isPined: false
    },
    pricing: {
      isOpen: true,
      isPined: false,
      showConfirmations: {
        selfPay: true
      }
    },
    timeline: {
      isOpen: true,
      isPined: false
    },
    isNew: false,
    isConfirmationPins: true
  },
  patientChartTags: {
    showConfirmations: {
      remove: true
    }
  }
};

export const defaultPracticeSettings = {
  // When false (default), a kiosk card-present payment is prompted immediately on
  // landing. When true, the patient reviews the invoice first and taps to pay.
  require_invoice_review: false
};

export const selfScheduling = {
  show_services: true,
  show_service_price: false,
  default_service_id: null,
  payment: {
    payment_requirement: 'none',
    card_charge_timing: 'day_of',
    card_charge_time: '05:00'
  }
};

export const chartLinks = [
  { label: 'Overview', path: '', icon: 'health-mono', end: true },
  {
    label: 'Profile',
    path: 'profile',
    permission: 'patients.read',
    icon: 'note-text-1-mono'
  },
  {
    label: 'Health records',
    path: 'health-records',
    permission: 'patients_medical_history.read',
    icon: 'document-text-mono'
  },
  {
    label: 'Clinical notes',
    path: 'clinical-notes',
    permission: 'clinical_note.read',
    icon: 'note-mono'
  },
  {
    label: 'Orders',
    path: 'orders',
    icon: 'prescribe-mono',
    children: [
      { label: 'Orders', path: 'orders', icon: 'prescribe-mono' },
      { label: 'Prescriptions', path: 'orders/prescriptions', icon: 'prescribe-mono' },
      { label: 'Referral requests', path: 'orders/requests', icon: 'prescribe-mono' }
    ]
  },
  {
    label: 'Appointments',
    path: 'appointments',
    permission: 'appointments.read',
    icon: 'calendar-2-mono'
  },
  {
    label: 'Billing',
    path: 'billing',
    permission: 'billing.read',
    icon: 'billing-mono',
    children: [
      {
        label: 'Ledger',
        path: 'billing/ledger',
        permission: 'billing.read',
        icon: 'macro-mono'
      },
      {
        label: 'Superbills',
        path: 'billing/superbill',
        permission: 'billing.read',
        icon: 'billing-mono'
      },
      {
        label: 'Claims',
        path: 'billing/claims',
        permission: 'billing.read',
        icon: 'wallet-mono'
      }
    ]
  },
  {
    label: 'Invoices & payments',
    path: 'payments',
    icon: 'wallet-mono',
    children: [
      { label: 'Invoices', path: 'payments/invoices', icon: 'file-invoice-mono' },
      { label: 'Payments', path: 'payments/payments', icon: 'billing-mono' },
      { label: 'Packages', path: 'payments/packages', icon: 'wallet-mono' },
      { label: 'Quotes', path: 'payments/quotes', icon: 'wallet-mono' },
      { label: 'Payment methods', path: 'payments/methods', icon: 'wallet-mono' }
    ]
  },
  {
    label: 'Communications',
    path: 'communications',
    permission: 'patient_communication.read',
    icon: 'messages-mono'
  },
  {
    label: 'Documents',
    path: 'documents',
    permission: 'patient_documents_center.read',
    icon: 'document-text-mono'
  }
];
